import { render, staticRenderFns } from "./create-abroadorder.vue?vue&type=template&id=12b16d5b&"
import script from "./create-abroadorder.vue?vue&type=script&lang=ts&"
export * from "./create-abroadorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports